(() => {
  const selector = '[data-cng-sale-terms][data-sale-start][data-sale-end]';
  let timer;

  function updateVisibility() {
    clearTimeout(timer);
    const now = Date.now();
    let nextBoundary = Infinity;

    document.querySelectorAll(selector).forEach((terms) => {
      const start = Date.parse(terms.dataset.saleStart);
      const end = Date.parse(terms.dataset.saleEnd);
      const valid = Number.isFinite(start) && Number.isFinite(end) && start < end;
      const active = valid && start <= now && now < end;
      terms.hidden = !active;

      if (valid && start > now) nextBoundary = Math.min(nextBoundary, start);
      if (valid && end > now) nextBoundary = Math.min(nextBoundary, end);
    });

    if (Number.isFinite(nextBoundary)) {
      timer = setTimeout(updateVisibility, Math.min(nextBoundary - now + 25, 2147483647));
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cng-sale-terms] .cng-sale-terms__trigger');
    if (trigger) {
      const dialog = trigger.closest('[data-cng-sale-terms]').querySelector('.cng-sale-terms__dialog');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const close = event.target.closest('[data-cng-sale-terms] .cng-sale-terms__close');
    if (close) close.closest('.cng-sale-terms__dialog').close();
    if (event.target.matches('.cng-sale-terms__dialog')) event.target.close();
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateVisibility();
  });
  document.addEventListener('shopify:section:load', updateVisibility);
  updateVisibility();
})();
